// todo: remove this, moved to content-string-utils
import { snakeCase, capitalize } from 'lodash';

export function phraseize(str: string) {
  return capitalize(snakeCase(str).replace(/_/g, ' '));
}
